import React, { FunctionComponent } from 'react'
import { cn } from 'ethcss'
import Icon from '../../blocks.simple/icon/icon'
import { color } from 'theme'
import { ICheckboxProps } from './Checkbox-types'
import { checkboxStyles } from './Checkbox-styles'

export const Checkbox: FunctionComponent<ICheckboxProps> = ({
    checked = false,
    disabled = false,
    label,
    className,
    onClick,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onClick?.(e.target.checked, e)
    }

    return (
        <label className={cn(checkboxStyles.root, className, disabled && checkboxStyles.disabled)}>
            <input
                type="checkbox"
                className={checkboxStyles.input}
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
            />
            <span className={cn(checkboxStyles.box, checked && checkboxStyles.boxChecked)}>
                {checked && (
                    <Icon
                        type="checkbox"
                        size={10}
                        color={color.fontWhiteUltraHigh}
                        containerClass={checkboxStyles.icon}
                    />
                )}
            </span>
            {label != null && label !== '' && <span className={checkboxStyles.label}>{label}</span>}
        </label>
    )
}
